import { render, staticRenderFns } from "./IosPrompt.vue?vue&type=template&id=844b8aa8&scoped=true"
import script from "./IosPrompt.vue?vue&type=script&lang=js"
export * from "./IosPrompt.vue?vue&type=script&lang=js"
import style0 from "./IosPrompt.vue?vue&type=style&index=0&id=844b8aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.2_webpack@5.75.0__ejs@3.1.8_lodash@4.17.21_vue-template-compiler@2.7.14_webpack@5.75.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844b8aa8",
  null
  
)

export default component.exports